export const colors = Object.freeze({
  RECHARGING_AVAILABLE: "#181C56",
  RECHARGING_NOT_AVAILABLE: "#F44336",
  UNKNOWN: "#e8e3e3",
});
